<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('DELETE_ACCOUNT.TITLE') }}
      </v-card-title>
      <v-card-text>
        <p>
          {{ $t('DELETE_ACCOUNT.DESCRIPTION') }}
        </p>

        <div v-if="deletePressed">
          <h3>
            {{ $t('DELETE_ACCOUNT.CAUTION') }}
          </h3>
          <p>
            {{ $t('DELETE_ACCOUNT.IS_PERMANENT') }}
          </p>
        </div>

      </v-card-text>

      <div v-if="deleting" class="text-center pb-8">
        {{ $t('DELETE_ACCOUNT.DELETING') }}
        <BaseLoader />
      </div>
      <div v-if="deleted" class="text-center pb-8 px-8">
        {{ $t('DELETE_ACCOUNT.DELETED') }}
        <BaseButton
          class="mt-4"
          @click="$router.push({ name: 'logout' })"
        >
          {{ $t('DELETE_ACCOUNT.EXIT') }}
        </BaseButton>
      </div>

      <v-card-actions v-if="!hideButtons">
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="close"
        >
          {{ $t('DELETE_ACCOUNT.NO') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="deleteAccount"
        >
          {{ $t('DELETE_ACCOUNT.YES') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteAccountModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    hideButtons: false,
    deletePressed: false,
    deleting: false,
    deleted: false,
  }),
  methods: {
    close() {
      this.$emit('input', false);
    },
    deleteAccount() {
      if (!this.deletePressed) {
        this.deletePressed = true;
        return false;
      }

      this.hideButtons = true;
      this.deleting = true;

      this.$store.dispatch('session/deleteAccount')
        .then(() => {
          this.deleting = false;
          this.deleted = true;
        });
      this.$track('delete_account', this.$route.name);
      return true;
    },
  },
};
</script>
